<div class="ckeditor-container mt-1">
  @if (placeholders?.length) {
    <div class="placeholder-container d-flex mb-2">
      @for (placeholder of placeholders; track placeholder) {
        <div
          class="data-placeholder-tag cta-btn"
          [attr.title]="placeholder.description || null"
          (click)="addPlaceholder(placeholder.placeholder)"
        >
          @if (translation) {
            <span>{{ 'ck_editor.' + placeholder.label | transloco }}</span>
          }
          @if (!translation) {
            <span>{{ placeholder.label }}</span>
          }
        </div>
      }
    </div>
  }
  @if (label) {
    <div class="editor-label">
      {{ label | transloco }}
    </div>
  }
  <div class="editor-busy-wrapper" [class.is-busy]="busy">
    <ckeditor
      #editorElement
      class="ckeditor mb-0"
      [editor]="editor"
      [formControl]="control"
      [config]="ckconfig"
      [disabled]="busy"
      (change)="onEditorChange($event)"
      (ready)="onEditorReady($event)"
    ></ckeditor>
    <!-- Veil + centred spinner: a read-only CKEditor looks identical to an editable one, so
    without this the operator cannot tell that something is writing into the field. -->
    @if (busy) {
      <div class="editor-busy-veil">
        <mat-spinner [diameter]="32"></mat-spinner>
      </div>
    }
  </div>
  @if (charCounter) {
    <div class="char-counter" [ngClass]="{ error: charCounter > charMax }">
      {{ charCounter }}{{ countOnly ? '' : '/' + charMax }}
    </div>
  }
  @if (control.invalid) {
    <div class="mat-error">
      @if (control.errors.charMax) {
        {{ 'form.error.description_too_long' | transloco }}
      }
    </div>
  }
</div>
